import { useForm } from "react-hook-form";
import { z } from "zod";
import { useAtom } from "jotai";
import { zodResolver } from "@hookform/resolvers/zod";
import { currentStep } from "@/app/store";
import { personalFormSchema } from "./components/PersonalInfoForm";
import { addressFormSchema } from "./components/AddressForm";
import { contactReferencesSchema } from "./components/ContactReferencesForm";
import { bankFormSchema } from "./components/BankInfoForm";

const formSchema = z.object({
  personalInfo: personalFormSchema,
  address: addressFormSchema,
  contactReferences: contactReferencesSchema,
  bankAccount: bankFormSchema,
});

export type formData = z.infer<typeof formSchema>;

export default function usePersonalInfo() {
  const [step, setStep] = useAtom(currentStep);
  const form = useForm<formData>({ resolver: zodResolver(formSchema) });

  const steps = {
    personalInfo: step === 0,
    address: step === 1,
    contactReferences: step === 2,
    bankInfo: step === 3,
    success: step === 4,
  };

  const title = [
    "Informações do cliente",
    "Endereço do cliente",
    "Referências de contato",
    "Dados bancários do cliente",
  ];

  return {
    steps,
    title,
    form,
    step,
    setStep,
  };
}
